var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Router } from '@angular/router';
import { from, empty } from 'rxjs';
import { ListingsService } from '../services/listings.service';
import { PreRenderService } from '../services/pre-render.service';
import { CommunicationService } from '../services/communication.service';
import { ListingCategory } from '../classes/enums';
import { catchError, map } from 'rxjs/operators';
import { Commercial, QuebecStateShort } from '../app-config.constants';
import { AnalyticsService } from '../services/analytics/analytics.service';
import { OFFMARKET_ACTIVE_LISTING, OFFMARKET_OFFMARKET_PROPERTY } from '../classes/analytics-tags';
import { UrlSanitizerService } from '../services/url-sanitizer.service';
import { UrlValidator } from './url-validator';
var OffMarketListingResolver = /** @class */ (function (_super) {
    __extends(OffMarketListingResolver, _super);
    function OffMarketListingResolver(_listingsService, _analyticsService, _communicationService, _urlSanitizerService, _preRenderService, _router) {
        var _this = _super.call(this, _urlSanitizerService, _router, _preRenderService) || this;
        _this._listingsService = _listingsService;
        _this._analyticsService = _analyticsService;
        _this._communicationService = _communicationService;
        _this._urlSanitizerService = _urlSanitizerService;
        _this._preRenderService = _preRenderService;
        _this._router = _router;
        return _this;
    }
    OffMarketListingResolver.prototype.resolve = function (route, rstate) {
        var _this = this;
        var url = rstate.root.firstChild.url;
        var listingIdWithBoardPrefix = '0';
        var listingIdRegex = /-(\w+_\w+)-prty/;
        var pathToBeChecked = url.length === 4 ? url[3].path : url[2].path;
        var isCommercial = url[0].path === Commercial;
        var isQuebec = url[0].path === QuebecStateShort.toLowerCase() || url[1].path === QuebecStateShort.toLowerCase();
        var listingCategory = isCommercial ? ListingCategory.COMMERCIAL : ListingCategory.RESIDENTIAL;
        this._communicationService.setCurrentListingType(listingCategory);
        var listingIdMatches = listingIdRegex.exec(pathToBeChecked);
        if (listingIdMatches && listingIdMatches.length === 2)
            listingIdWithBoardPrefix = listingIdMatches[1];
        if (!this.isValidUrl(url))
            return empty();
        return from(this._listingsService.getListingDetails(listingIdWithBoardPrefix)).pipe(map(function (listing) {
            _this._communicationService.setCurrentListingType(_this.getListingCategory(listing));
            if (listing.isOffMarket) {
                _this._analyticsService.eventTrack(OFFMARKET_OFFMARKET_PROPERTY, null);
            }
            else {
                _this._analyticsService.eventTrack(OFFMARKET_ACTIVE_LISTING, null);
            }
            return listing;
        }), catchError(function (err) {
            return _this.redirectOnError(url, isQuebec, isCommercial);
        }));
    };
    OffMarketListingResolver.prototype.redirectOnError = function (url, isQuebec, isCommercial) {
        var fallbackUrl = url.length === 4 ? url[0] + '/' + url[1] + '/' + url[2] : url[0] + '/' + url[1];
        // MBL-2919 - Removed redirect temporarily until MBL - 2900 completed
        if (isQuebec)
            fallbackUrl = isCommercial ? "/" + Commercial : '/';
        this.navigationRedirect(fallbackUrl);
        return empty();
    };
    OffMarketListingResolver.prototype.getListingCategory = function (listing) {
        if (listing.isLuxury) {
            return ListingCategory.LUXURY;
        }
        else if (listing.isCommercial) {
            return ListingCategory.COMMERCIAL;
        }
        return this._communicationService.listings.currentShownListingType.getValue();
    };
    return OffMarketListingResolver;
}(UrlValidator));
export { OffMarketListingResolver };
